<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card style="background-color: #f4f5fa;">
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <div>
        <slot></slot>
      </div>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref, onMounted, computed, watch, toRefs } from 'vue'
import { formatTime, formatDate, loading } from '@/utils/helper'

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Diary Summary',
  },
})
const { value, bookingInfoProp } = toRefs(props)

const dialog = ref(value.value)

const emits = defineEmits(['input', 'closed'])
watch(dialog, val => {
  console.log('diaryDialog', val)
  emits('input', val)
})

watch(value, val => {
  console.log('value', val)
  dialog.value = val
})

onMounted(() => {
  dialog.value = value.value
})
</script>
